"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userDto = exports.roleName = exports.createCompanyRequest = exports.companyDto = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
exports.companyDto = zod_1.z.object({
    id: common_1.uuid,
    tenantId: common_1.uuid,
    legalNameAr: zod_1.z.string().min(1),
    legalNameEn: zod_1.z.string().nullable(),
    /** الرقم الضريبى — يُتحقق منه عند تهيئة التكامل الضريبى لا قبله. */
    taxRegistrationNumber: zod_1.z.string().nullable(),
    commercialRegistryNumber: zod_1.z.string().nullable(),
    functionalCurrency: common_1.currencyCode,
    createdAt: zod_1.z.string(),
});
exports.createCompanyRequest = zod_1.z
    .object({
    legalNameAr: zod_1.z.string().min(2).max(200),
    legalNameEn: zod_1.z.string().max(200).nullish(),
    taxRegistrationNumber: zod_1.z.string().max(32).nullish(),
    commercialRegistryNumber: zod_1.z.string().max(32).nullish(),
    functionalCurrency: common_1.currencyCode.default('EGP'),
    /** بداية السنة المالية الأولى. */
    fiscalYearStart: common_1.isoDate,
})
    .strict();
exports.roleName = zod_1.z.enum(['owner', 'accountant', 'clerk', 'viewer']);
exports.userDto = zod_1.z.object({
    id: common_1.uuid,
    email: zod_1.z.string().email(),
    displayName: zod_1.z.string(),
    role: exports.roleName,
});
//# sourceMappingURL=company.js.map